import React, { useState, useMemo, useEffect } from 'react';
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import { Box, FormControl, Select, MenuItem, Grid, Stack, Avatar, Typography, InputAdornment, Table, TableBody, TableCell, TableContainer, TableSortLabel, TableHead, TableRow, TablePagination } from '@mui/material'
import { format } from 'date-fns';
import RankingCard from '../components/RankingCard';
import axios from 'lib/axios'
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { filterVisibleLeaderboardStaff } from '../helpers/hiddenStaff';

const Leaderboard = () => {

  // leaderboard data is fetched into `performanceRes` below
  const OverallIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.34334 0.865L2.33084 0.88625L2.32667 0.894167L2.28917 0.9575C2.25751 1.01278 2.21278 1.09236 2.15501 1.19625C1.99152 1.4914 1.83316 1.78936 1.68001 2.09C1.14756 3.13828 0.662074 4.20976 0.225007 5.30125C-0.113327 6.14542 -0.07416 7.10333 0.370007 7.9175C0.920443 8.92461 1.52522 9.90105 2.18167 10.8425C1.92837 11.5508 1.79911 12.2974 1.79959 13.0496C1.79959 16.6579 4.72542 19.5833 8.33376 19.5833C11.9421 19.5833 14.8679 16.6583 14.8679 13.0492C14.8679 12.275 14.7329 11.5321 14.4858 10.8429C15.1423 9.90133 15.7471 8.92475 16.2975 7.9175C16.7413 7.10333 16.7808 6.14542 16.4425 5.30083C16.0053 4.20947 15.5197 3.13813 14.9871 2.09C14.7924 1.70807 14.5893 1.33048 14.3779 0.9575L14.3413 0.894167L14.3388 0.89L14.3242 0.865C14.2642 0.7655 14.1842 0.679629 14.0891 0.612897C13.994 0.546165 13.886 0.500046 13.7721 0.4775C10.5546 -0.159167 6.11626 -0.159167 2.89542 0.4775C2.78148 0.500046 2.6735 0.546165 2.57842 0.612897C2.48335 0.679629 2.40328 0.7655 2.34334 0.865ZM13.5992 9.17917C14.0382 8.50926 14.4502 7.82204 14.8342 7.11917C14.9323 6.93636 14.9887 6.73407 14.9992 6.52687C15.0098 6.31967 14.9744 6.1127 14.8954 5.92083C14.497 4.92581 14.0566 3.94813 13.5754 2.99042C13.466 3.17208 13.3464 3.36931 13.2167 3.58208C12.4978 4.76094 11.7602 5.92831 11.0042 7.08375C12.0353 7.54692 12.9292 8.26873 13.5992 9.17917ZM9.33334 6.59083C9.68584 6.0575 10.0208 5.54125 10.3333 5.05208C9.66859 4.9906 9.00135 4.95987 8.33376 4.96C7.58167 4.96 6.90709 4.99875 6.33376 5.0525C6.66342 5.56788 6.9969 6.08081 7.33417 6.59125C7.99668 6.48948 8.67084 6.48906 9.33334 6.59083ZM5.66334 7.08417C4.78118 5.73572 3.92409 4.37104 3.09251 2.99083C2.611 3.94853 2.17033 4.92621 1.77167 5.92125C1.69278 6.11314 1.6574 6.32013 1.66806 6.52734C1.67872 6.73454 1.73517 6.9368 1.83334 7.11958C2.21734 7.82246 2.62934 8.50968 3.06834 9.17958C3.73825 8.269 4.63217 7.54703 5.66334 7.08375M8.33376 8.18208C5.64542 8.18208 3.46626 10.3613 3.46626 13.0492C3.46626 15.7375 5.64542 17.9167 8.33376 17.9167C11.0221 17.9167 13.2013 15.7375 13.2013 13.0492C13.2013 10.3613 11.0221 8.18208 8.33376 8.18208ZM8.97042 9.75208C8.70292 9.23625 7.96459 9.23625 7.69709 9.75208L6.99459 11.1063L5.50834 11.3992C4.96209 11.5067 4.74126 12.1683 5.11334 12.5825L6.17292 13.7608L5.97834 15.34C5.90792 15.9075 6.49834 16.325 7.01042 16.0692L8.33376 15.4096L9.65709 16.07C10.1688 16.3254 10.7592 15.9079 10.6892 15.34L10.4946 13.7613L11.5542 12.5829C11.9263 12.1688 11.7054 11.5071 11.1592 11.3996L9.67292 11.1071L8.97042 9.75208Z" fill="#3A3A3A" />
    </svg>
  )

  const QualityIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
      <path d="M4.95833 7.33333L2.9375 5.33333L3.8125 4.45833L4.9375 5.58333L7.02083 3.5L7.89583 4.375L4.95833 7.33333ZM13.8333 15L8.58333 9.75C8.16667 10.0833 7.6875 10.3472 7.14583 10.5417C6.60417 10.7361 6.02778 10.8333 5.41667 10.8333C3.90278 10.8333 2.62167 10.3089 1.57333 9.26C0.525 8.21111 0.000555996 6.93 4.40917e-07 5.41667C-0.000555115 3.90333 0.523889 2.62222 1.57333 1.57333C2.62278 0.524444 3.90389 0 5.41667 0C6.92944 0 8.21083 0.524444 9.26083 1.57333C10.3108 2.62222 10.835 3.90333 10.8333 5.41667C10.8333 6.02778 10.7361 6.60417 10.5417 7.14583C10.3472 7.6875 10.0833 8.16667 9.75 8.58333L15 13.8333L13.8333 15ZM5.41667 9.16667C6.45833 9.16667 7.34389 8.80222 8.07333 8.07333C8.80278 7.34444 9.16722 6.45889 9.16667 5.41667C9.16611 4.37444 8.80167 3.48917 8.07333 2.76083C7.345 2.0325 6.45944 1.66778 5.41667 1.66667C4.37389 1.66556 3.48861 2.03028 2.76083 2.76083C2.03306 3.49139 1.66833 4.37667 1.66667 5.41667C1.665 6.45667 2.02972 7.34222 2.76083 8.07333C3.49195 8.80444 4.37722 9.16889 5.41667 9.16667Z" fill="black" />
    </svg>
  )

  const EfficiencyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.79424 0.4744C1.82267 0.340178 1.89579 0.219866 2.00139 0.133534C2.10699 0.0472024 2.23869 7.01462e-05 2.37453 0H8.13786C8.23779 0.000104674 8.33609 0.0256967 8.42363 0.0744049C8.51117 0.123113 8.58513 0.193362 8.63865 0.278642C8.69217 0.363921 8.72353 0.461474 8.72982 0.562259C8.7361 0.663045 8.71712 0.763804 8.67461 0.8552L6.94878 4.572H11.4233C11.5294 4.57201 11.6335 4.60075 11.7249 4.65523C11.8163 4.70971 11.8916 4.78794 11.9429 4.88178C11.9942 4.97562 12.0197 5.08165 12.0167 5.18882C12.0138 5.296 11.9824 5.40041 11.926 5.4912L5.56969 15.7192C5.49878 15.8331 5.39204 15.9196 5.26663 15.9648C5.14121 16.01 5.0044 16.0113 4.87817 15.9684C4.75195 15.9256 4.64363 15.8412 4.57062 15.7286C4.49761 15.6161 4.46415 15.4821 4.47561 15.348L4.96644 9.628H0.593278C0.504863 9.62793 0.41758 9.60791 0.337802 9.56939C0.258024 9.53088 0.187765 9.47484 0.132154 9.40539C0.0765433 9.33593 0.0369854 9.25479 0.0163684 9.16791C-0.00424863 9.08103 -0.00540422 8.99059 0.012986 8.9032L1.79424 0.4744ZM2.85507 1.2L1.32715 8.428H5.61403C5.69633 8.42802 5.77772 8.44533 5.85305 8.47883C5.92837 8.51232 5.99599 8.56128 6.05159 8.62259C6.1072 8.6839 6.14959 8.75622 6.17607 8.83496C6.20255 8.9137 6.21253 8.99715 6.2054 9.08L5.87053 12.9784L10.349 5.772H6.01382C5.91382 5.77203 5.81543 5.74654 5.72778 5.69788C5.64013 5.64923 5.56607 5.579 5.51245 5.4937C5.45883 5.40839 5.4274 5.31079 5.42108 5.20994C5.41476 5.10909 5.43374 5.00826 5.47628 4.9168L7.20211 1.2H2.85507Z" fill="black" />
    </svg>
  )

  const VolumeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M6.66732 9.04815L10.0007 10.9532M6.66732 9.04815L3.33398 10.9532M6.66732 9.04815V5.23898M10.0007 10.9532V14.7623L13.334 16.6673M10.0007 10.9532L6.66732 12.8582M10.0007 10.9532L13.334 9.04815V5.23898M10.0007 10.9532V7.14232L13.334 5.23898M10.0007 10.9532L13.334 12.8573M3.33398 10.9532V14.7623L6.66732 16.6673M3.33398 10.9532L6.66732 12.8582M6.66732 5.23898L10.0007 3.33398L13.334 5.23898M6.66732 5.23898L10.0007 7.14315M6.66732 12.8582V16.6673M13.334 12.8573L16.6673 10.9523M13.334 12.8573V16.6673M10.0007 14.7615L6.66732 16.6673M13.334 16.6673L16.6673 14.7623V10.9523M13.334 9.04732L16.6673 10.9523" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )

  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const [performanceRes, setPerformanceRes] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [fetchError, setFetchError] = useState(null)
  const [performanceCardsRes, setPerformanceCardsRes] = useState(null)

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  // totalCount is no longer needed — pagination is now client-side (sortedData.length is used instead)
  // const [totalCount, setTotalCount] = useState(0)


  // fetch company leaderboard for selected month (start_date/end_date)
  useEffect(() => {
    const getMonthRange = (year, monthValue) => {
      const start = new Date(year, monthValue - 1, 1)
      const end = new Date(year, monthValue, 0) // last day of month
      const fmt = (d) => format(d, 'yyyy-MM-dd')
      return { start_date: fmt(start), end_date: fmt(end) }
    }

    const { start_date, end_date } = getMonthRange(currentYear, selectedMonth)

    setIsLoading(true)
    setFetchError(null)

    axios.get('/leaderboard/company', {
      params: {
        // start_date, 
        // end_date,
        // page: page + 1,
        // limit: rowsPerPage
        start_date,
        end_date,
        limit: 500
      }
    })
      .then((res) => {
        // lib/axios getData usually unwraps data; fallback to res.data
        const data = res.data?.data ?? res.data;
        setPerformanceRes(data);
        // setTotalCount(data?.pagination?.total_items ?? 0);
      })
      .catch((err) => {
        console.error('Failed to fetch company leaderboard', err)
        setFetchError(err)
      })
      .finally(() => setIsLoading(false))

    // page and rowsPerPage removed from deps — API now fetches all at once (limit: 500), pagination is client-side
  }, [selectedMonth, currentYear])

  // fetch performance cards used by the top summary cards
  useEffect(() => {
    const getMonthRange = (year, monthValue) => {
      const start = new Date(year, monthValue - 1, 1)
      const end = new Date(year, monthValue, 0) // last day of month
      const fmt = (d) => format(d, 'yyyy-MM-dd')
      return { start_date: fmt(start), end_date: fmt(end) }
    }

    const { start_date, end_date } = getMonthRange(currentYear, selectedMonth)

    axios.get('/leaderboard/performance-cards', { params: { start_date, end_date } })
      .then((res) => {
        setPerformanceCardsRes(res.data?.data ?? res.data)
      })
      .catch((err) => {
        console.warn('Failed to fetch performance cards', err)
      })
  }, [selectedMonth, currentYear])

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('Leaderboard API ->', { performanceRes, isLoading, fetchError })
  }, [performanceRes, isLoading, fetchError])

  const personalRankings = useMemo(() => {
    // tolerate server shape; expect performanceCardsRes to be the data object
    const api = performanceCardsRes ?? {};

    // if missing, return placeholders
    if (!api || (!api.company && !api.team)) {
      const placeholder = (title, id) => ({ id, title, rank: '—', total: '—', label: 'Company', department: 'Team', icon: <OverallIcon /> });
      return {
        company: [placeholder('Overall', 1), placeholder('Quality', 2), placeholder('Efficiency', 3), placeholder('Volume', 4)],
        department: [placeholder('Overall', 5), placeholder('Quality', 6), placeholder('Efficiency', 7), placeholder('Volume', 8)],
      };
    }

    return {
      company: [
        { id: 1, title: 'Overall', rank: api.company?.overall?.rank ?? '—', total: api.company?.overall?.total_staff ?? '—', label: api.company?.company_name || api.company?.name || 'Company', icon: <OverallIcon /> },
        { id: 2, title: 'Quality', rank: api.company?.quality?.rank ?? '—', total: api.company?.quality?.total_staff ?? '—', label: api.company?.company_name || api.company?.name || 'Company', icon: <QualityIcon /> },
        { id: 3, title: 'Efficiency', rank: api.company?.efficiency?.rank ?? '—', total: api.company?.efficiency?.total_staff ?? '—', label: api.company?.company_name || api.company?.name || 'Company', icon: <EfficiencyIcon /> },
        { id: 4, title: 'Volume', rank: api.company?.volume?.rank ?? '—', total: api.company?.volume?.total_staff ?? '—', label: api.company?.company_name || api.company?.name || 'Company', icon: <VolumeIcon /> },
      ],
      department: [
        { id: 5, title: 'Overall', rank: api.team?.overall?.rank ?? '—', total: api.team?.overall?.total_staff ?? '—', department: api.team?.name || 'Team', icon: <OverallIcon /> },
        { id: 6, title: 'Quality', rank: api.team?.quality?.rank ?? '—', total: api.team?.quality?.total_staff ?? '—', department: api.team?.name || 'Team', icon: <QualityIcon /> },
        { id: 7, title: 'Efficiency', rank: api.team?.efficiency?.rank ?? '—', total: api.team?.efficiency?.total_staff ?? '—', department: api.team?.name || 'Team', icon: <EfficiencyIcon /> },
        { id: 8, title: 'Volume', rank: api.team?.volume?.rank ?? '—', total: api.team?.volume?.total_staff ?? '—', department: api.team?.name || 'Team', icon: <VolumeIcon /> },
      ],
    };
  }, [performanceCardsRes]);

  // leaderboard rows derived from API (fallback to empty until fetched)
  const leaderboardRows = useMemo(() => {
    const list = filterVisibleLeaderboardStaff(performanceRes?.leaderboard || []).map(item => ({
      id: item.staff_id,
      name: item.name,
      OverallRank: item.overall_rank,
      OverallScore: item.overall_score,
      QualityRank: item.quality_rank,
      QualityScore: item.quality_score,
      EfficiencyRank: item.efficiency_rank,
      EfficiencyScore: item.efficiency_score,
      VolumeRank: item.volume_rank,
      VolumeScore: item.volume_score,
      department: item.department,
      profile_image: item.profile_image,
      is_current_user: item.is_current_user,
      color: null
    }))

    return list
  }, [performanceRes])

  const departmentOptions = useMemo(() => {
    const base = leaderboardRows ?? []

    // get unique department names (ignore null/empty)
    const unique = Array.from(
      new Set(
        base
          .map((r) => (r.department || '').trim())
          .filter(Boolean)
      )
    ).sort((a, b) => a.localeCompare(b))

    // include the default "Teams" option as the "all" option
    return ['Teams', ...unique]
  }, [leaderboardRows])

  const [selectedDept, setSelectedDept] = useState('Teams');

  useEffect(() => {
    if (!departmentOptions.length) return
    if (!departmentOptions.includes(selectedDept)) {
      setSelectedDept('Teams')
    }
  }, [departmentOptions, selectedDept])

  useEffect(() => {
    setPage(0);
  }, [selectedMonth, selectedDept])

  // legacy performance-cards fetch removed — using /api/leaderboard/company with date range instead
  // month array
  const getMonthArray = () => {
    const monthArray = []
    for (let i = 0; i < 12; i++) {
      const value = i + 1
      const monthName = format(new Date(currentYear, i), 'MMMM')
      const label = value === currentMonth ? 'This month' : monthName
      monthArray.push({ name: monthName, value, label })
    }
    return monthArray
  }

  // sort logic
  const [sortBy, setSortBy] = useState('OverallRank');
  const [sortOrder, setSortOrder] = useState('asc');

  const handleSort = (property) => {
    const isAsc = sortBy === property && sortOrder === 'asc';
    const newOrder = isAsc ? 'desc' : 'asc';

    setSortOrder(newOrder);
    setSortBy(property);

  };

  const sortedData = useMemo(() => {
    const base = leaderboardRows || []

    // apply department filter when a specific team selected
    const filtered = selectedDept && selectedDept !== 'Teams'
      ? base.filter(r => r.department === selectedDept)
      : base

    const sorted = [...filtered]

    sorted.sort((a, b) => {
      let aValue, bValue

      if (sortBy === 'name') {
        aValue = (a.name || '').toLowerCase()
        bValue = (b.name || '').toLowerCase()
      } else {
        aValue = a[sortBy]
        bValue = b[sortBy]
      }

      // nulls/end-of-list handling
      if (aValue == null && bValue == null) return 0
      if (aValue == null) return 1
      if (bValue == null) return -1

      // Convert to numbers for rank/score columns to prevent string sorting
      const isNumericColumn = sortBy.includes('Rank') || sortBy.includes('Score')
      if (isNumericColumn) {
        aValue = parseFloat(aValue) || 0
        bValue = parseFloat(bValue) || 0
      }

      if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1
      if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1
      return 0
    })

    return sorted
  }, [sortBy, sortOrder, leaderboardRows, selectedDept])

  // slice sortedData for the current page (client-side pagination)
  const paginatedData = sortedData.slice(page * rowsPerPage, (page + 1) * rowsPerPage)

  return (
    <DashboardContainer headerTitle="Leaderboard" noPadding={true} sx={{ overflowY: 'auto' }}>
      <Box>

        <Box mb="24px">
          <Typography variant="h3" fontWeight="500" color="#000000">
            Performance Leaderboard
          </Typography>

          <Typography sx={{
            fontSize: '12px',
            fontWeight: 400,
            color: '#000000'
          }}>
            Performance rankings across quality, efficiency, and volume this month.
          </Typography>
        </Box>

        <Box mb={6}>
          {/* Company Rankings */}
          {isLoading && (
            <Typography sx={{ mb: 2, color: 'text.secondary' }}>Loading performance data…</Typography>
          )}
          <Grid container spacing={2.5} mb={3}>
            {personalRankings.company.map((ranking) => (
              <Grid item xs={12} sm={6} md={3} key={ranking.id}>
                <RankingCard
                  title={ranking.title}
                  rank={ranking.rank}
                  total={ranking.total}
                  label={ranking.label}
                  iconSvg={ranking.icon}
                // iconColor={ranking.iconColor}
                />
              </Grid>
            ))}
          </Grid>

          {/* Department Rankings */}
          <Grid container spacing={2.5}>
            {personalRankings.department.map((ranking) => (
              <Grid item xs={12} sm={6} md={3} key={ranking.id}>
                <RankingCard
                  title={ranking.title}
                  rank={ranking.rank}
                  total={ranking.total}
                  label={ranking.department}
                  iconSvg={ranking.icon}
                // iconColor={ranking.iconColor}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box>
          {/* Leaderboard Ranking */}
          <Typography variant="h3" fontWeight="500" color="#000000" mb={1.5}>Company Leaderboard</Typography>

          <Box display="flex" flexDirection="row" justifyContent="start" alignItems="center" gap="12px" mb={4}>
            <Typography fontSize="14px" fontWeight="500" color="#000000">Filter By:</Typography>

            <Box display="flex" flexDirection="row" justifyContent="start" alignItems="center" gap="12px">

              {/* Team dropdown */}
              <FormControl>
                <Select
                  value={selectedDept}
                  onChange={(e) => setSelectedDept(e.target.value)}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Select Team Department' }}
                  //add icon to the left
                  startAdornment={
                    <InputAdornment position="start">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M12 8.25C13.245 8.25 14.2425 7.245 14.2425 6C14.2425 4.755 13.245 3.75 12 3.75C10.755 3.75 9.75 4.755 9.75 6C9.75 7.245 10.755 8.25 12 8.25ZM6 8.25C7.245 8.25 8.2425 7.245 8.2425 6C8.2425 4.755 7.245 3.75 6 3.75C4.755 3.75 3.75 4.755 3.75 6C3.75 7.245 4.755 8.25 6 8.25ZM6 9.75C4.2525 9.75 0.75 10.6275 0.75 12.375V13.5C0.75 13.9125 1.0875 14.25 1.5 14.25H10.5C10.9125 14.25 11.25 13.9125 11.25 13.5V12.375C11.25 10.6275 7.7475 9.75 6 9.75ZM12 9.75C11.7825 9.75 11.535 9.765 11.2725 9.7875C11.2875 9.795 11.295 9.81 11.3025 9.8175C12.1575 10.44 12.75 11.2725 12.75 12.375V13.5C12.75 13.7625 12.6975 14.0175 12.615 14.25H16.5C16.9125 14.25 17.25 13.9125 17.25 13.5V12.375C17.25 10.6275 13.7475 9.75 12 9.75Z" fill="#3A3A3A" />
                      </svg>
                    </InputAdornment>
                  }
                  sx={{
                    minWidth: '135px',
                    maxHeight: '37px',
                    borderRadius: '100px',
                    outline: 'none !important',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderRadius: '100px',
                      border: '1px solid #3A3A3A',
                    },
                    '&.Mui-focused': {
                      outline: 'none !important',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: '1px solid #3A3A3A',
                      outline: 'none !important',
                    },
                    '&:focus': {
                      outline: 'none !important',
                    },
                    '&:focus-visible': {
                      outline: 'none !important',
                    },
                    '& .MuiSelect-select': {
                      outline: 'none !important',
                    },
                    '& .MuiSelect-select:focus': {
                      backgroundColor: '#f9f9f9',
                      outline: 'none !important',
                    },
                    '& .MuiSelect-select:focus-visible': {
                      outline: 'none !important',
                    },
                    backgroundColor: '#f9f9f9',
                  }}
                >
                  {departmentOptions.map((deptName) => (
                    <MenuItem key={deptName} value={deptName}>
                      {deptName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Filter by month dropdown (calendar)*/}
              <Box>
                <FormControl>
                  <Select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    displayEmpty
                    startAdornment={
                      <InputAdornment position="start">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M14.25 14.25H3.75V6H14.25M12 0.75V2.25H6V0.75H4.5V2.25H3.75C2.9175 2.25 2.25 2.9175 2.25 3.75V14.25C2.25 14.6478 2.40804 15.0294 2.68934 15.3107C2.97064 15.592 3.35218 15.75 3.75 15.75H14.25C14.6478 15.75 15.0294 15.592 15.3107 15.3107C15.592 15.0294 15.75 14.6478 15.75 14.25V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H13.5V0.75M12.75 9H9V12.75H12.75V9Z" fill="#3A3A3A" />
                        </svg>
                      </InputAdornment>
                    }
                    sx={{
                      minWidth: '173px',
                      maxHeight: '37px',
                      borderRadius: '100px',
                      outline: 'none !important',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '100px',
                        border: '1px solid #3A3A3A',
                      },
                      '&.Mui-focused': {
                        outline: 'none !important',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #3A3A3A',
                        outline: 'none !important',
                      },
                      '&:focus': {
                        outline: 'none !important',
                      },
                      '&:focus-visible': {
                        outline: 'none !important',
                      },
                      '& .MuiSelect-select': {
                        outline: 'none !important',
                      },
                      '& .MuiSelect-select:focus': {
                        backgroundColor: '#f9f9f9',
                        outline: 'none !important',
                      },
                      '& .MuiSelect-select:focus-visible': {
                        outline: 'none !important',
                      },
                      backgroundColor: '#f9f9f9',
                    }}
                  >
                    {getMonthArray().map((month) => (
                      <MenuItem key={month.value} value={month.value}>
                        {month.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

            </Box>
          </Box>

          {/* Tanle Ranking */}
          <TableContainer sx={{
            border: 'none',
            maxHeight: {
              xs: '300px',
              sm: '350px',
              md: '400px',
              lg: '500px',
              xl: '700px',
            },
            overflowY: 'auto'
          }}
          >
            <Table sx={{
              [`& .MuiTableCell-root`]: {
                borderBottom: "none"
              }
            }}>
              <TableHead>
                <TableRow>

                  {/* 1. Sort by Alphabet */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('name')}>
                      <Typography fontWeight={700}>Team Member</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'name' ? 1 : 0.4,
                          transform: sortBy === 'name' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                  {/* Overall Rank - Sortable */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('OverallRank')}>
                      <Typography fontWeight={700}>Overall Rank</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'OverallRank' ? 1 : 0.4,
                          transform: sortBy === 'OverallRank' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                  {/* Overall Score - Sortable */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('OverallScore')}>
                      <Typography fontWeight={700}>Overall Score</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'OverallScore' ? 1 : 0.4,
                          transform: sortBy === 'OverallScore' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                  {/* Quality Rank - Sortable */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('QualityRank')}>
                      <Typography fontWeight={700}>Quality Rank</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'QualityRank' ? 1 : 0.4,
                          transform: sortBy === 'QualityRank' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                  {/* Quality Score - Sortable */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('QualityScore')}>
                      <Typography fontWeight={700}>Quality Score</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'QualityScore' ? 1 : 0.4,
                          transform: sortBy === 'QualityScore' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                  {/* Efficiency Rank - Sortable */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('EfficiencyRank')}>
                      <Typography fontWeight={700}>Efficiency Rank</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'EfficiencyRank' ? 1 : 0.4,
                          transform: sortBy === 'EfficiencyRank' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                  {/* Efficiency Score - Sortable */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('EfficiencyScore')}>
                      <Typography fontWeight={700}>Efficiency Score</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'EfficiencyScore' ? 1 : 0.4,
                          transform: sortBy === 'EfficiencyScore' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                  {/* Volume Rank - Sortable */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('VolumeRank')}>
                      <Typography fontWeight={700}>Volume Rank</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'VolumeRank' ? 1 : 0.4,
                          transform: sortBy === 'VolumeRank' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                  {/* Volume Score - Sortable */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer', outline: 'none', '&:focus': { outline: 'none' } }} onClick={() => handleSort('VolumeScore')}>
                      <Typography fontWeight={700}>Volume Score</Typography>
                      <SwapVertIcon
                        sx={{
                          fontSize: '16px',
                          opacity: sortBy === 'VolumeScore' ? 1 : 0.4,
                          transform: sortBy === 'VolumeScore' && sortOrder === 'desc' ? 'scaleY(-1)' : 'none'
                        }}
                      />
                    </Box>
                  </TableCell>

                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedData.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      backgroundColor: row.is_current_user ? 'rgba(255, 249, 196, 0.6)' : 'inherit'
                    }}
                  >
                    <TableCell component="th" scope="row">
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Avatar src={row.profile_image} sx={{ bgcolor: row.color, width: 32, height: 32 }}>
                          {/* Icon or Initial */}
                        </Avatar>
                        <Typography variant="body2" fontWeight={row.is_current_user ? 700 : 500}>{row.name}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell align="center">{row.OverallRank ?? '—'}</TableCell>
                    <TableCell align="center">{row.OverallScore != null ? `${row.OverallScore}%` : '0%'}</TableCell>
                    <TableCell align="center">{row.QualityRank ?? '—'}</TableCell>
                    <TableCell align="center">{row.QualityScore != null ? `${row.QualityScore}%` : '0%'}</TableCell>
                    <TableCell align="center">{row.EfficiencyRank ?? '—'}</TableCell>
                    <TableCell align="center">{row.EfficiencyScore != null ? `${row.EfficiencyScore}%` : '0%'}</TableCell>
                    <TableCell align="center">{row.VolumeRank ?? '—'}</TableCell>
                    <TableCell align="center">{row.VolumeScore != null ? `${row.VolumeScore}%` : '0%'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination part */}
          {sortedData.length > 0 && (
            <Box
              sx={{
                borderTop: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'flex-end',
                backgroundColor: '#f7f9fa',
                position: 'sticky',
                bottom: 0,
                zIndex: 10
              }}
            >
              <TablePagination
                component="div"
                count={sortedData.length}
                page={page}
                onPageChange={(event, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                showFirstButton={true}
                showLastButton={true}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
                sx={{
                  '& .MuiTablePagination-toolbar': {
                    minHeight: '48px',
                    paddingLeft: 0,
                    paddingRight: 0
                  },
                }}
              />
            </Box>
          )}
        </Box>

      </Box>


    </DashboardContainer >
  )
}

export default Leaderboard
